import validators from '../../../utils/validators';
import DrugManufacturer from '../manufacturer';
import DrugFormat from '../format';
import DrugPrescriptionIngredient from './ingredient';
import DrugStock from '../stock';
import DrugPackage from '../package';
import DrugPrescriptionAnalog from './analog';

class DrugPrescriptionDrug {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      name: (v) => validators.isNotEmptyString(v),
      description: (v) => validators.isStringOrNull(v),
      measure: (v) => validators.isNumberOrNull(v),
      measureUnit: (v) => validators.isStringOrNull(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid DrugPrescriptionDrug property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }

    try {
      this.manufacturer = data.manufacturer ? new DrugManufacturer(data.manufacturer) : null;
      this.format = new DrugFormat(data.format);
      this.ingredient = new DrugPrescriptionIngredient(data.ingredient);
      this.stocks = data.stocks.map(i => new DrugStock(i));
      this.packages = data.packages.map(i => new DrugPackage(i));
      this.analogs = data.analogs.map(i => new DrugPrescriptionAnalog(i));
    } catch (e) {
      throw new Error(`Error in DrugPrescriptionDrug in ${data.id}: ${e.message}`);
    }
  }
}

export default DrugPrescriptionDrug;
